/*import { Notyf } from 'notyf'; //I didn't like how narrow each one was
import 'notyf/notyf.min.css';

const core = new Notyf({
	duration: 0
	,ripple: false
	,position: {x:'right', y:'top'}
	,dismissible: true
	});

export default {//make it possible to simply pass in a message
	success: function(message,options){
		return core.success({message, ...options});
		}
	,error: function(message,options){
		return core.error({message, ...options});
		}
	}*/

import Toastify from 'toastify-js'; //https://github.com/apvarun/toastify-js/blob/master/README.md
import "toastify-js/src/toastify.css";

//One other option? https://www.cssscript.com/stackable-notification-bar-library-notify-js/ - https://www.cssscript.com/demo/stackable-notification-bar-library-notify-js/
var allToasts = [];
function newToast(text,className,options){
	const newToast = Toastify({
		text,
		duration: options && options.duration || -1, //-1 is stay open until close
		//destination: "https://github.com/apvarun/toastify-js",
		//newWindow: true,
		close: true,
		className,
		//gravity: "top", // `top` or `bottom`
		position: "center", // `left`, `center` or `right` //for mobile
		backgroundColor: "transparent" //unset/none - unset the defalt linear-gradient(to right, #00b09b, #96c93d)",
		//stopOnFocus: true, // Prevents dismissing of toast on hover
		//onClick: function(){} // Callback after click
		});
	allToasts.push(newToast);
	newToast.showToast();
	}

const map = {
	primary: 'bg-primary'
	,secondary: 'bg-secondary'

	,success: 'bg-success'
	,green: 'bg-success'

	,danger: 'bg-danger'
	,red: 'bg-danger'
	,error: 'bg-danger'

	,warning: 'bg-warning'
	,info: 'bg-info'
	,light: 'bg-light'
	,dark: 'bg-dark'
	,white: 'bg-white'
	}

export default function(text, type, options){
	if(type && map[type]) type=map[type];
	else type='bg-info';

	return newToast(text, type, options);
	}

export function closeAll(){
	allToasts.forEach(s=>s.hideToast());
	}